import { AxiosResponse } from 'axios';
import environment from '@environment';
import { MessageActionResponse, MessageRequest, MessageResponse } from 'core/models/general/inbox';
import { EndpointHelper } from 'core/services/endpoint.helper';
import { HttpClient } from 'core/services/http';

export class InboxService {
  private static apiBuilder = new EndpointHelper(`${environment.UTILITY_API_URI}/mymessages`);

  static getInboxData(customerNumber: string, country: string): Promise<MessageResponse> {
    const url = this.apiBuilder.createUrl()
      .addRouteParam(customerNumber)
      .addRouteParam(country)
      .addRouteParam('getinboxdata')
      .build();

    return HttpClient.GetInstance.get<MessageResponse>(url)
      .then(
        (res: AxiosResponse<MessageResponse>) => (
          res?.data
        )
      );
  }

  static readInboxMessage(customerNumber: string, requestObject: MessageRequest): Promise<MessageActionResponse> {
    const url = this.apiBuilder.createUrl()
      .addRouteParam(customerNumber)
      .addRouteParam('readinboxmessages')
      .build();

    return HttpClient.GetInstance.post<MessageRequest, MessageActionResponse>(url, requestObject)
      .then(
        (res: AxiosResponse<MessageActionResponse>) => (
          res?.data as MessageActionResponse
        )
      );
  }

  static deleteInboxMessage(customerNumber: string, requestObject: MessageRequest): Promise<MessageActionResponse> {
    const url = this.apiBuilder.createUrl()
      .addRouteParam(customerNumber)
      .addRouteParam('deleteinboxmessages')
      .build();

    return HttpClient.GetInstance.post<MessageRequest, MessageActionResponse>(url, requestObject)
      .then(
        (res: AxiosResponse<MessageActionResponse>) => (
          res?.data as MessageActionResponse
        )
      );
  }
}